module.exports = __webpack_public_path__ + "static/img/empty.240a935.png";


//////////////////
// WEBPACK FOOTER
// ./static/home2.0/empty.png
// module id = Oug7
// module chunks = 14